<template>
  <div :class="{
    'diagnosis-item-wrap': true,
    'diagnosis-item-wrap-hor': direction === 'horizontal'
  }"
  >
      <!-- 标题 -->
      <div  @click="closeToolTip">
        <Title :data="data" v-if="direction==='vertical'"/>
      </div>
      <!-- 指标 -->
      <div  @click="closeToolTip">
        <Indicators :data="data.indicators" :direction="direction" :showCompareInfo="showCompareInfo"/>
      </div>
      <!-- top10菜品 -->
      <TopItems v-if="data.chartkey === 'menu'" :itemData="data.itemTop10"/>
      <!-- 用户及转化漏斗图 -->
      <FunnelChart v-if="data.chartkey==='usersAndConversion'" :itemData="data.funnelData"></FunnelChart>
      <!-- 图表 -->
      <charts v-if="data.chartData" :options="data.chartData" :height="data.chartHeight" :direction="direction" :chartkey="data.chartkey" @showHorCharts="showHorCharts"/>
  </div>
</template>

<script>
import Title from './title/index.vue'
import TopItems from './TopItems/index.vue'
import FunnelChart from './FunnelChart/index.vue'
import Indicators from './Indicators/index.vue'
import charts from '../charts/index.vue'
import { chartKeyForHorShow } from './../../utils/builder.js'
import EventBus from './../../utils/eventBus'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    direction: {
      type: String,
      default: 'vertical'
    },
    showCompareInfo: {
      type: Boolean,
      default: false
    },
  },
  components: {
    Title,
    Indicators,
    charts,
    TopItems,
    FunnelChart
  },
  methods: {
    // 用于通知图表点击了其他区域，隐藏图表的tooltip
    closeToolTip() {
      EventBus.$emit('handleToolTipClose', '')
    },
    showHorCharts(key) {
      const chartKey = chartKeyForHorShow.indexOf(key)
      this.$emit('showHorChartsItem', chartKey)
    }
  }
}

</script>
<style lang="scss" scoped>
.diagnosis-item-wrap {
  position: relative;
  padding: 24px;
  margin-top: 24px;
  border-radius: 8px;
  background: #FFFFFF;
  overflow: hidden;

  .tips {
    position: relative;
    display: flex;
    margin-top: 24px;
    align-items: flex-start;
    line-height: 28px;
    margin-bottom: 12px;

    i {
      width: 24px;
      height: 24px;
      line-height: 24px;
      color: #8D9099;
      margin-right: 4px;
      font-size: 20px;
    }

    span {
      line-height: 24px;
      font-family: PingFangSC-Regular;
      font-size: 20px;
      color: #8D9099;
      font-weight: 400;
      flex: 1;
    }
  }

  .action-container {
    position: relative;
    margin-top: 24px;
    background-image: linear-gradient(180deg, #FFF8F3 0%, #FFFFFF 100%);
    padding: 16px 24px 8px;
    .action-title {
      font-family: DiDiSans-Pro-Bold;
      font-size: 24px;
      color: #F76A31;
      line-height: 36px;
      font-weight: 600;
    }

    .action-wrap {
      position: relative;
      .action-item {
        position: relative;
        display: flex;
        align-items: flex-start;
        margin-top: 16px;
        margin-bottom: 24px;
        i {
          display: block;
          width: 16px;
          height: 16px;
          opacity: 0.5;
          border: 3px solid #F76A31;
          margin-right: 16px;
          box-sizing: border-box;
          border-radius: 16px;
          margin-top: 8px;
        }

        p {
          flex: 1;
          font-family: PingFangSC-Regular;
          font-size: 24px;
          color: #595C66;
          line-height: 32px;
          font-weight: 400;
        }
      }
    }
  }
}
.diagnosis-item-wrap-hor{
  margin-top: 0px
}
</style>
